export default __webpack_public_path__ + "static/media/connect.0c1f219b.svg";